/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Enum for the status of the account's keys.
 */
export enum CreditAccountKeysStatus {
  ACTIVE = 'ACTIVE',
  ON_HOLD = 'ON_HOLD',
}
